/**
 * DinoRaceView
 *
 * Embeds the dino race mini-game into the main canvas area.
 * Uses an iframe for now - could be ported to full React later.
 */

import { useEffect } from 'react';

interface DinoRaceViewProps {
  roomCode?: string;
  playerName?: string;
  onClose: () => void;
}

export function DinoRaceView({ roomCode, playerName, onClose }: DinoRaceViewProps) {
  const params = new URLSearchParams();
  if (roomCode) params.set('room', roomCode);
  if (playerName) params.set('player', playerName);
  const raceUrl = params.toString() ? `/dino-race.html?${params}` : '/dino-race.html';

  // Escape key to close
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [onClose]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        backgroundColor: '#1a0a0a',
        position: 'relative',
      }}
    >
      {/* Top bar — always clickable, not covered by iframe */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '6px 12px',
        background: 'linear-gradient(180deg, #2d1f15 0%, #1a0a0a 100%)',
        borderBottom: '1px solid rgba(212, 175, 55, 0.2)',
        flexShrink: 0,
      }}>
        <button
          onClick={onClose}
          title="Return to Battle Map"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            padding: '6px 14px',
            background: 'transparent',
            border: '1px solid rgba(212, 175, 55, 0.4)',
            borderRadius: '4px',
            color: '#d4af37',
            fontSize: '13px',
            fontWeight: 600,
            fontFamily: 'Georgia, serif',
            cursor: 'pointer',
          }}
        >
          ← Back to Map
        </button>

        <span style={{ color: 'rgba(212, 175, 55, 0.4)', fontSize: 10, fontFamily: 'Georgia, serif' }}>
          Press ESC to exit
        </span>

        {/* Prominent X close button */}
        <button
          onClick={onClose}
          title="Close Raptor Dash (ESC)"
          style={{
            width: 32,
            height: 32,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'rgba(239, 68, 68, 0.15)',
            border: '1px solid rgba(239, 68, 68, 0.4)',
            borderRadius: '4px',
            color: '#ef4444',
            fontSize: '18px',
            fontWeight: 700,
            cursor: 'pointer',
            lineHeight: 1,
          }}
        >
          ✕
        </button>
      </div>

      {/* Race iframe */}
      <iframe
        src={raceUrl}
        title="Raptor Dash"
        style={{
          flex: 1,
          width: '100%',
          border: 'none',
        }}
      />
    </div>
  );
}
